import { useMutation } from '@tanstack/react-query'
import { useEffect } from 'react'
import { fetchApiWithToken } from '~/api/utils'
import type { ApplicationInfosResponse } from '../types'

export const useMarkApplicationSeen = (applicationId?: number): void => {
  const { mutate } = useMutation({
    retry: 2,
    mutationFn: async (id: number) =>
      await fetchApiWithToken<ApplicationInfosResponse>({
        method: 'get',
        url: `/v1/applications/${id}?seen=1`
      })
  })

  useEffect(() => {
    if (applicationId) {
      mutate(applicationId)
    }
  }, [applicationId, mutate])
}
